// extracted by mini-css-extract-plugin
module.exports = {"root":"Questions_root__31g8Z"};